import React from "react";
import {
  Card,
  CardHeader,
  useMediaQuery,
  Typography,
  Avatar,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  card: {
    minHeight: 150,
    display: "flex",
    flexDirection: "column",
    flex: "1",
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  cardMobile: {
    minHeight: 150,
    display: "flex",
    flexDirection: "column",
    flex: "1",
  },
  cardAvatar: {
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.main,
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  cardHeader: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
}));

const CrewCard = ({
  children,
  title,
  icon,
  showDivider = true,
  action,
  subheader,
  addMargin = true,
}) => {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const classes = useStyles();

  return addMargin ? (
    <div className={classes.root}>
      <InnerCard
        classes={classes}
        isSmall={isSmall}
        title={title}
        icon={icon}
        showDivider={showDivider}
        action={action}
        subheader={subheader}
      >
        {children}
      </InnerCard>
    </div>
  ) : (
    <InnerCard
      classes={classes}
      isSmall={isSmall}
      title={title}
      icon={icon}
      showDivider={showDivider}
      action={action}
      subheader={subheader}
    >
      {children}
    </InnerCard>
  );
};

const InnerCard = ({
  classes,
  isSmall,
  children,
  title,
  icon,
  showDivider = true,
  action,
  subheader,
}) => {
  return (
    <Card
      className={isSmall ? classes.cardMobile : classes.card}
      variant="outlined"
    >
      {title && (
        <CardHeader
          action={action}
          subheader={subheader}
          className={classes.cardHeader}
          title={<Typography variant="h5">{title}</Typography>}
          avatar={
            icon ? <Avatar className={classes.cardAvatar}>{icon}</Avatar> : null
          }
        />
      )}
      {showDivider && <Divider className={classes.divider} />}
      {children}
    </Card>
  );
};

export default CrewCard;
